import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-service-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './service-badge.component.html',
  styleUrl: './service-badge.component.scss'
})
export class ServiceBadgeComponent {
  @Input() label: string | undefined;
  @Input() type: 'service' | 'status' | 'priority' = 'service'; // Preparado para ser universal

  // Mapeo de colores centralizado
  private readonly colorMap: Record<string, string> = {
    'reactivo': '#2196F3',
    'preventivo': '#F44336',
    'correctivo': '#FF9800',
    'prueba': '#9C27B0',
    'clima': '#00BCD4',
    'cortinas': '#8D6E63',
    'inversión': '#4CAF50',
    'inversion': '#4CAF50',
    'siniestro': '#607D8B',
    'proyecto': '#E91E63',
    'm2': '#009688',
  };

  getColor(): string {
    if (!this.label) return 'transparent';
    const key = this.label.trim().toLowerCase();
    return this.colorMap[key] || '#95a5a6'; // Gris si no reconoce el tipo
  }
}